import { Component, HostListener, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PizzaLasanhaPrecoStatusRequest, ProdutoPizzaLasanhaComEmpresa, ProdutoPizzaLasanhaQtdSabores, ProdutoResponse, ProdutosParaVendaRequest, ProdutosPizzaLasanhaComEmpresa, Tamanho } from "../../models/produto.model";
import { ProdutoService } from "src/app/core/services/http/produto.service";
import { Paginador } from "../../models/paginador.model";
import { AuthenticationService } from "src/app/core/services/http/authentication.service";
import { BehaviorSubject, forkJoin, Subscription, take } from "rxjs";
import { ValoresPorSabor } from "./integracao-pizza-lasanha.viewmodel";
import { PizzaLasanhaGrid } from "src/app/pages/integracao/grid-pizzas-lasanhas/pizza-lasanha-grid.viewmodel";
import { PizzaLasanhaService } from "src/app/core/services/behavior/pizza-lasanha.service";
import { CastModelUtils } from "../../utils/CastModelUtils";
import { ModalController } from "@ionic/angular";
import { CadastroPizzaLasanhaComponent } from "../cadastro-pizza-lasanha/cadastro-pizza-lasanha.component";
import { PizzaLasanhaRequest } from "../../interfaces/pizza-lasanha.interface";
import { ToastService } from "src/app/core/services/behavior/toast.service";
import { TipoPrecoEnum } from "../../enums/tipo-preco.enum";
import { CadastroIngredientesService } from "src/app/core/services/behavior/cadastro-ingredientes.service";

import { IngredienteProdutoViewModel, IngredienteProdutoRequest, IngredienteLoteProdutoComposicaoRequest } from "../../models/produto.model";

@Component({
    selector: 'app-integracaoPizzaLasanha',
    templateUrl: './integracao-pizza-lasanha.component.html',
    styleUrls: ['./integracao-pizza-lasanha.component.scss'],
})
export class IntegracaoPizzaLasanha {
    @ViewChild('containerProdutos') containerProdutos: any;

    public tipo: TipoProduto = 'PIZZA';
    public titulo: string = 'CADASTRO DE ';
    public tituloBase: string = '';
    public produtoPorPagina: ProdutosPizzaLasanhaComEmpresa[] = [];
    public produtosFiltrados: ProdutosPizzaLasanhaComEmpresa[] = [];
    public tamanhosProdutos: string[] = [];
    public termo: string = '';
    public tipoPreco: TipoPrecoEnum = TipoPrecoEnum.Padrao;
    public statusPrecoIntegracao: boolean = false;

    private debounceTimeout: any;
    private produtos: ProdutoResponse[] = [];
    public pizzasLasanhas: ProdutoResponse[] = [];
    private susbscriptions$: Subscription[] = [];
    public carregandoProdutos: boolean = false;
    public carregandoIngredientes: boolean = false;
    public enviandoIngrediente: boolean = false;
    public tamanhos: Tamanho[] = [];
    public tamanhosLasanha: Tamanho[] = [];
    public sabores: string[] = [];
    public pizzaLasanhaGrid: PizzaLasanhaGrid[] = [];
    public pizzaLasanhaFiltradaGrid: PizzaLasanhaGrid[] = [];
    public produtoPizzaLasanhaQtdSabores: ProdutoPizzaLasanhaQtdSabores[] = [];

    public indexItemSelecionado: number = -1;
    public paginador = new Paginador(0, 48, 0);

    public inpFocado: boolean = false;
    public saborSelecionadoParaIngredientes: boolean = false;
    public nomeSaborIngredientes: string = '';

    public ingredientesSaborSelecionado: IngredienteProdutoViewModel[] = [];
    public listaIngredientesGeral: IngredienteProdutoViewModel[] = [];
    public codigosProdutosIngrediente: number[] = [];

    constructor(
        private route: ActivatedRoute,
        private modalCtrl: ModalController,
        private produtoService: ProdutoService,
        private router: Router,
        private pizzaLasanhaService: PizzaLasanhaService,
        private authService: AuthenticationService,
        private toastService: ToastService,
        private cadastroIngredientesService: CadastroIngredientesService
    ) { }

    ionViewWillEnter() {
        this.tipo = this.obterTipo();

        if (this.tipo === null) {
            this.router.navigate(['/']);
        }

        this.carregarTitulo(this.tipo);
        this.recuperarProdutos();
        this.carregarStatusPrecoIntegracao();

        setTimeout(() => this.carregarPaginador(), 500);
    }

    @HostListener('document:keydown', ['$event'])
    keydown(event: KeyboardEvent) {
        if (!this.inpFocado) {
            switch (event.key) {
                case 'ArrowLeft':
                    this.alterarPagina(this.paginador.paginaAtual - 1);
                    break;
                case 'ArrowRight':
                    this.alterarPagina(this.paginador.paginaAtual + 1)
                    break;
                case 'ArrowUp':
                    this.alterarItemSelecionado(this.indexItemSelecionado - 1);
                    break;
                case 'ArrowDown':
                    this.alterarItemSelecionado(this.indexItemSelecionado + 1);
            }
        }
    }

    private obterTipo(): TipoProduto | null {
        const tipo = this.route.snapshot.paramMap.get('tipo').toUpperCase() as TipoProduto | null;
        return tipo;
    }

    private recuperarProdutos() {
        let grid$: BehaviorSubject<PizzaLasanhaGrid[]>;
        let tamanho$: BehaviorSubject<Tamanho[]>;

        if (this.tipo === 'PIZZA') {
            grid$ = this.pizzaLasanhaService.pizzaGrid;
            tamanho$ = this.pizzaLasanhaService.tamanhosPizza;
        } else {
            grid$ = this.pizzaLasanhaService.lasanhaGrid;
            tamanho$ = this.pizzaLasanhaService.tamanhosLasanha;
        }

        const sub = forkJoin({
            grid: grid$.pipe(take(1)),
            tamanhos: tamanho$.pipe(take(1))
        }).subscribe(({ grid, tamanhos }) => {
            if (tamanhos === null || grid === null) {
                this.carregarProdutos();
                return;
            }

            this.pizzaLasanhaGrid = grid.map((r) => CastModelUtils.ClonarObjetoComPropriedadesIguais(r, new PizzaLasanhaGrid()));

            this.tamanhos = tamanhos.map((t) => CastModelUtils.ClonarObjetoComPropriedadesIguais(t, new Tamanho()));

            this.pesquisar(this.termo);
        });

        this.susbscriptions$.push(sub);
    }
    
    private carregarStatusPrecoIntegracao() {
        const status = localStorage.getItem('statusPrecoIntegracao');
        this.statusPrecoIntegracao = status ? JSON.parse(status) : false;   
    }

    public alterarStatusAtualizacaoPrecoIntegracao(event: any) {
        this.statusPrecoIntegracao = event.checked;
        localStorage.setItem('statusPrecoIntegracao', JSON.stringify(this.statusPrecoIntegracao));
    }

    private carregarProdutosPizzaLasanhaQtdSabores() {
        this.produtoService.getAllProdutosPizzaLasanhaQtdSabores().subscribe((res) => {
            if (res.success && res.data.length > 0) {
                this.produtoPizzaLasanhaQtdSabores = res.data;
            }
        })
    }

    private carregarProdutos() {
        const sub = this.authService.isAuthenticated.subscribe((autenticado) => {
            if (!autenticado) return;

            this.statusSpinnerCarregamento(true);
            this.carregarSaboresETamanhos(this.tipo);
            this.carregarProdutosPizzaLasanhaQtdSabores();
        });

        this.susbscriptions$.push(sub);
    }

    private carregarTitulo(tipoProduto: string) {
        this.tituloBase = `CADASTRO DE ${tipoProduto}`;
        this.titulo = this.tituloBase;
    }

    private carregarSaboresETamanhos(tipo: TipoProduto) {
        const isPizza = tipo === 'PIZZA';

        const sabores$ = isPizza
            ? this.produtoService.getSaboresPizzaPrecosPorTamanho()
            : this.produtoService.getSaboresLasanhaPrecoPorTamanho();

        const tamanhos$ = isPizza
            ? this.produtoService.getTamanhosPizza()
            : this.produtoService.getTamanhosLasanha();

        forkJoin({
            sabores: sabores$,
            tamanhos: tamanhos$,
            produtos: this.produtoService.getAllComExcluidos(), // this.produtoService.getAll(),
            pizzasLasanhas: this.produtoService.getPizzaLasanha()
        }).subscribe({
            next: ({ sabores: resSabores, tamanhos: resTamanhos, produtos: resProdutos, pizzasLasanhas: resPizzasLasanhas }) => {
                this.sabores = resSabores.data;
                this.tamanhos = resTamanhos.data.filter((tamanho) => tamanho.nome !== "BORDAS");
                this.produtos = (resProdutos as any).data.produtos || resProdutos.data;                
                this.pizzasLasanhas = (resPizzasLasanhas as any).data.produtos || resPizzasLasanhas.data;                

                this.preencherSaborTamanhoTipo(this.tipo);
            },
            error: () => this.statusSpinnerCarregamento(false),
        });
    }

    public preencherSaborTamanhoTipo(tipo: TipoProduto) {
        let valoresPorSabores: ValoresPorSabor[] = [];

        for (const sabor of this.sabores) {
            for (const tamanho of this.tamanhos) {
                const novoValorPorSabor = new ValoresPorSabor();

                novoValorPorSabor.sabor = sabor;
                novoValorPorSabor.tamanho = tamanho.nome;
                novoValorPorSabor.tipoProduto = tipo;

                const nomeNormalizado = this.normalizarNomeProduto(novoValorPorSabor.nomeProduto);
                var produtoPizzaDB = this.pizzasLasanhas.find(p => this.normalizarNomeProduto(p.nome) === nomeNormalizado);
                novoValorPorSabor.ativo = produtoPizzaDB ? produtoPizzaDB.ativo : false;
                novoValorPorSabor.usarPrecoPromocionalInicial = produtoPizzaDB ? produtoPizzaDB.precoPromocionalAtivo : false;
                novoValorPorSabor.usarPrecoPromocional = produtoPizzaDB ? produtoPizzaDB.precoPromocionalAtivo : false

                valoresPorSabores.push(novoValorPorSabor);
            }

            //isso aqui é para marcar o ativo das pizzas
            var itensDoSabor = valoresPorSabores.filter(s => s.sabor === sabor);
            const existeItemAtivo = itensDoSabor.find(l => l.ativo === true) != null; //se existir 1, marca todos
            const existePrecoPromocionalAtivo = itensDoSabor.find(l => l.usarPrecoPromocionalInicial === true) != null; 

            itensDoSabor.forEach(l => {
                l.ativo = existeItemAtivo;
                if (existePrecoPromocionalAtivo) {
                    l.usarPrecoPromocionalInicial = true;
                    l.usarPrecoPromocional = true;
                }
            });
        }

        this.preencherValorVendaECodigo(valoresPorSabores);
    }

    private normalizarNomeProduto(nome: string): string {
        return nome ? nome.trim().replace(/\s+/g, ' ').toUpperCase() : '';
    }

    private preencherValorVendaECodigo(valoresPorSaborSemProcoVenda: ValoresPorSabor[]) {
        const mapProdutos = this.obterMapListaProdutoPizzaLasanha(this.pizzasLasanhas);

        for (let valorPorSabor of valoresPorSaborSemProcoVenda) {            
            const key = this.normalizarNomeProduto(valorPorSabor.nomeProduto);   

            const produto = mapProdutos.get(key);
            
            if (produto !== undefined) {
                valorPorSabor.precoVenda = produto.venda;
                valorPorSabor.precoVendaInicial = produto.venda;
                valorPorSabor.precoVendaPromocional = produto.vendaPromocional;
                valorPorSabor.precoVendaPromocionalInicial = produto.vendaPromocional;
                valorPorSabor.codigoProduto = produto.codigo;
            };
        }

        const valoresPorSaborComPrecoVenda = valoresPorSaborSemProcoVenda;

        this.unificarSaboresIguais(valoresPorSaborComPrecoVenda, this.tipo);
    }

    private unificarSaboresIguais(valoresPorSabor: ValoresPorSabor[], tipo: TipoProduto) {        
        const mapProdutosComMesmoTamanho = new Map<string, PizzaLasanhaGrid>();

        for (const sabor of valoresPorSabor) {
            if (sabor.sabor.trim().length > 0) {
                let produtoProduto: PizzaLasanhaGrid = null;
                const produto = mapProdutosComMesmoTamanho.get(sabor.sabor);

                if (produto !== undefined) {
                    produto.tamanhos.push(sabor);
                    if (sabor.usarPrecoPromocionalInicial) {
                        produto.usarPrecoPromocional = true;
                    }
                } else {
                    const produtoGrid = new PizzaLasanhaGrid();

                    produtoGrid.sabor = sabor.sabor;
                    produtoGrid.tamanhos = [sabor];
                    produtoGrid.tipoProduto = tipo;
                    produtoGrid.usarPrecoPromocional = sabor.usarPrecoPromocionalInicial;

                    if (sabor.ativo)
                        produtoGrid.ativo = true;

                    mapProdutosComMesmoTamanho.set(sabor.sabor, produtoGrid);
                }
            }
        }
        
        this.pizzaLasanhaGrid = Array.from(mapProdutosComMesmoTamanho.values());

        this.atualizarPizzaLasanhaParaRecuperacao(this.pizzaLasanhaGrid.map((p) => CastModelUtils.ClonarObjetoComPropriedadesIguais(p, new PizzaLasanhaGrid())), tipo);
        this.statusSpinnerCarregamento(false);
        this.pesquisar(this.termo);
    }

    public async abrirCadastroPizzaLasanha() {
        const modal = await this.modalCtrl.create({
            component: CadastroPizzaLasanhaComponent,
            componentProps: {
                tamanhos: this.tamanhos
            },
            cssClass: 'full-screen-dialog'
        });

        await modal.present();

        const result = await modal.onDidDismiss<PizzaLasanhaRequest>();

        if (result.data.sabor.length > 0) {
            if (this.tipo === "PIZZA") {
                this.produtoService.adicionarSaborPizza(result.data).subscribe((res) => {
                    console.log(res);
                    // Adiconar na lista
                });
            } else {
                this.produtoService.adicionarSaborLasanha(result.data).subscribe((res) => {
                    console.log(res);
                    // Adiconar na lista
                });
            }
        } else {
            this.toastService.show('Formulário inválido');
        }
    }

    private atualizarPizzaLasanhaParaRecuperacao(pizzaLasanhaGrid: PizzaLasanhaGrid[], tipo: TipoProduto) {
        if (tipo === 'PIZZA') {
            this.pizzaLasanhaService.pizzaGrid.next(pizzaLasanhaGrid);
            this.pizzaLasanhaService.tamanhosPizza.next(this.tamanhos);
        } else {
            this.pizzaLasanhaService.lasanhaGrid.next(pizzaLasanhaGrid);
            this.pizzaLasanhaService.tamanhosLasanha.next(this.tamanhos);
        }
    }

    private obterMapListaProdutoPizzaLasanha(produtos: ProdutoResponse[]): Map<string, ProdutoResponse> {        
        const mapProdutos = new Map<string, ProdutoResponse>();
        produtos.forEach((valor) => {            
            const key = this.normalizarNomeProduto(valor.nome);
            mapProdutos.set(key, valor);
        });

        return mapProdutos;
    }

    private statusSpinnerCarregamento(status: boolean) {
        this.carregandoProdutos = status;
    }

    public carregarPaginador() {
        const tamanhoDisplay = this.containerProdutos.nativeElement.offsetHeight - 60;
        this.paginador = new Paginador(tamanhoDisplay, 48, 1);
    }

    public alterarItemSelecionado(index: number) {
        if (index === this.indexItemSelecionado) {
            return;
        }

        if (index < 0) {
            if (this.paginador.paginaAtual === 1) {
                this.indexItemSelecionado = -1;
            } else {
                this.alterarPagina(this.paginador.paginaAtual - 1);
                this.indexItemSelecionado = this.paginador.qtdItensPagina - 1;
            }

            return;
        }

        this.indexItemSelecionado = index;
    }

    public pesquisarComDebounce(termo: string) {
        clearTimeout(this.debounceTimeout);

        this.debounceTimeout = setTimeout(() => {
            this.pesquisar(termo);
        }, 500);
    }

    private pesquisar(termo: string) {
        const termoLower = termo.toLocaleLowerCase();        
        const produtosFiltrados = this.pizzaLasanhaGrid.filter((pizza) => pizza.sabor.toLocaleLowerCase().includes(termoLower));
        this.pizzaLasanhaFiltradaGrid = produtosFiltrados.sort((a, b) => a.sabor.localeCompare(b.sabor));;        

        this.carregarPaginas();
        this.indexItemSelecionado = 0;
    }

    public carregarPaginas() {
        this.calcularTotalPaginas();
        this.produtoPorPagina = this.paginador.paginar(this.produtosFiltrados);
    }

    public alterarPagina(pagina: number) {
        if (pagina > this.paginador.totalPaginas || pagina < 1) {
            return;
        }

        this.paginador.paginaAtual = pagina;
        this.carregarPaginas();
    }

    private calcularTotalPaginas() {
        this.paginador.calcularTotalPaginas(this.produtosFiltrados.length);
    }

    public alterarValorPizzaLasanha(p: ValoresPorSabor) {
        if (!this.temAlteracao(p)) return;

        if (!this.produtoValido(p)) {
            p.precoVenda = 0;
            p.precoVendaPromocional = 0;
            this.toastService.warning('Produto não encontrado para atualizar preço');
            return;
        }

        const valores = this.extrairValores(p);

        this.reverterEstado(p);

        this.atualizarPreco(valores, p);
    }

    private temAlteracao(p: ValoresPorSabor): boolean {
        return !(
            p.precoVendaInicial === p.precoVenda &&
            p.precoVendaPromocionalInicial === p.precoVendaPromocional &&
            p.usarPrecoPromocionalInicial === p.usarPrecoPromocional
        );
    }

    private extrairValores(p: ValoresPorSabor) {
        return {
            precoVenda: p.precoVenda,
            precoVendaPromocional: p.precoVendaPromocional
        };
    }

    private produtoValido(p: ValoresPorSabor): boolean {
        return p.codigoProduto !== 0;
    }

    private reverterEstado(p: ValoresPorSabor): void {
        p.precoVenda = p.precoVendaInicial;
        p.precoVendaPromocional = p.precoVendaPromocionalInicial;
    }

    private atualizarPreco(valores: { precoVenda: number; precoVendaPromocional: number }, p: ValoresPorSabor) {
        const request: PizzaLasanhaPrecoStatusRequest = {
            codigoProduto: p.codigoProduto,
            precoVenda: valores.precoVenda,
            precoVendaPromocional: valores.precoVendaPromocional,
            ativo: p.ativo,
            codigoTabelaPreco: Number(this.tipoPreco),
            usarPrecoPromocional: p.usarPrecoPromocional,
            atualizarPrecoIntegracao: this.statusPrecoIntegracao
        };

        this.produtoService.updatePizzaLasanhaPreco([request]).subscribe({
            next: (res) => {
                if (!res.success) return;

                this.aplicarValores(p, valores);
                this.atualizarPizzaLasanhaParaRecuperacao(this.pizzaLasanhaGrid, this.tipo);
            }
        });
    }

    // public alterarStatusUsarPrecoPromocional(pizzaLasanha: PizzaLasanhaGrid) {
    //     const request: PizzaLasanhaPrecoStatusRequest[] = [];

    //     pizzaLasanha.tamanhos.forEach((tamanho) => {
    //         request.push({
    //             codigoProduto: tamanho.codigoProduto,
    //             precoVenda: tamanho.precoVenda,
    //             precoVendaPromocional: tamanho.precoVendaPromocional,
    //             ativo: tamanho.ativo,
    //             usarPrecoPromocional: tamanho.usarPrecoPromocional,
    //             codigoTabelaPreco: Number(this.tipoPreco)
    //         });
    //     });        

    //     this.produtoService.updatePizzaLasanhaPreco(request).subscribe({
    //         next: (res) => {
    //             if (!res.success) return;
    //             pizzaLasanha.tamanhos.forEach((tamanho) => {
    //                 tamanho.precoVendaPromocional = tamanho.usarPrecoPromocional ? tamanho.precoVendaPromocional : tamanho.precoVenda;
    //                 tamanho.precoVendaPromocionalInicial = tamanho.precoVendaPromocional;
    //             });
    //             this.atualizarPizzaLasanhaParaRecuperacao(this.pizzaLasanhaGrid, this.tipo);
    //         }
    //     });
    // }

    private aplicarValores(p: ValoresPorSabor, valores: { precoVenda: number; precoVendaPromocional: number }) {
        p.precoVenda = valores.precoVenda;
        p.precoVendaInicial = valores.precoVenda;
        p.precoVendaPromocional = valores.precoVendaPromocional;
        p.precoVendaPromocionalInicial = valores.precoVendaPromocional;
    }

    public alterarPizzaLasanhaAtivo(pizzaLasanha: PizzaLasanhaGrid) {
        const pizzasLasanhasRequest: PizzaLasanhaPrecoStatusRequest[] = [];
        pizzaLasanha.processando = true;
        
        pizzaLasanha.tamanhos.forEach((tamanho) => {
            pizzasLasanhasRequest.push(PizzaLasanhaPrecoStatusRequest.Get(tamanho.codigoProduto, pizzaLasanha.ativo, tamanho.precoVenda, tamanho.precoVendaPromocional, Number(this.tipoPreco), pizzaLasanha.usarPrecoPromocional, this.statusPrecoIntegracao));
        });

        this.produtoService.updatePizzaLasanhaPreco(pizzasLasanhasRequest).subscribe((res) => {
            pizzaLasanha.processando = false;
        });
    }

    public alterarStatusPizzaLasanha(pizzaLasanha: ProdutosPizzaLasanhaComEmpresa) {
        const pizzasLasanhasRequest = new ProdutosParaVendaRequest();

        // pizzasLasanhas.forEach((pizzaLasanha) => {
        pizzaLasanha.caracteristicas.forEach(sabor => sabor.checked = pizzaLasanha.checked);

        let caracteristicasPizzasAlteradas: ProdutoPizzaLasanhaComEmpresa[] = [];

        pizzaLasanha.caracteristicas.forEach(caracteristica => {
            if (caracteristica.dataChanged) {
                caracteristicasPizzasAlteradas.push(caracteristica);
            }
        });

        if (caracteristicasPizzasAlteradas.length > 0) {
            caracteristicasPizzasAlteradas.forEach((caracteristica) => {
                const produtoRequest = new ProdutosParaVendaRequest();

                produtoRequest.checked = pizzaLasanha.checked;
                produtoRequest.produtoIntegracaoId = caracteristica.codigoIntegracao;
                produtoRequest.acrescimoPorCento = 0;
                produtoRequest.acrescimoReais = 0;
                produtoRequest.precoFinal = caracteristica.precoVenda;
            });
        }
        // });

        this.produtoService.updateProdutosIntegracao(pizzasLasanhasRequest).subscribe({
            next: (res) => {
                if (res.success) {
                    // pizzaLasanha.forEach((pizzaLasanha) => {
                    pizzaLasanha.caracteristicas.forEach((item) => item.dataChanged = false);
                    // })
                }
            }
        });
    }

    public limparTermo() {
        this.termo = '';
        this.pesquisar(this.termo);
    }

    public home() {
        this.router.navigateByUrl('/home');
    }

    public abrirIngredientes(sabor: PizzaLasanhaGrid) {
        const codigos = sabor.tamanhos.map(t => t.codigoProduto).filter(c => c > 0);
        this.codigosProdutosIngrediente = codigos;
        this.nomeSaborIngredientes = `${sabor.tipoProduto} ${sabor.sabor}`;
        this.saborSelecionadoParaIngredientes = true;
        this.titulo = `INGREDIENTES`;
        this.carregarIngredientesProduto();
    }

    public fecharIngredientes() {
        this.saborSelecionadoParaIngredientes = false;
        this.titulo = this.tituloBase;
    }

    private carregarIngredientesProduto() {
        if (!this.produtos || this.produtos.length === 0 || this.codigosProdutosIngrediente.length === 0) return;

        if (this.listaIngredientesGeral.length === 0) {
            this.carregandoIngredientes = true;
            this.produtoService.getIngredientes().subscribe({
                next: (res) => {
                    if (res.success) {
                        this.listaIngredientesGeral = [];
                        res.data.forEach(item => {
                            const produto = this.produtos.find(p => p.codigo === item.codigoProduto);
                            if (produto) {
                                this.listaIngredientesGeral.push({
                                    nome: produto.nome,
                                    codigo: produto.codigo
                                });
                            }
                        });
                        this.preencherIngredientesDoSabor();
                    } else {
                        this.carregandoIngredientes = false;
                    }
                },
                error: () => {
                    this.toastService.error('Erro ao carregar lista de ingredientes');
                    this.carregandoIngredientes = false;
                }
            });
        } else {
            this.preencherIngredientesDoSabor();
        }
    }

    private preencherIngredientesDoSabor() {
        if (this.codigosProdutosIngrediente.length === 0) return;

        this.carregandoIngredientes = true;
        this.produtoService.obterIngredientesLote(this.codigosProdutosIngrediente).subscribe({
            next: (res) => {
                if (res.success) {
                    this.ingredientesSaborSelecionado = res.data.map(item => ({
                        codigo: item.codigoProduto,
                        nome: item.nome
                    }));
                }
                this.carregandoIngredientes = false;
            },
            error: () => {
                this.toastService.error('Erro ao carregar ingredientes do sabor');
                this.carregandoIngredientes = false;
            }
        });
    }

    public adicionarIngredienteAoProduto(nomeIngrediente: string) {   
        if (this.codigosProdutosIngrediente.length === 0) return;

        this.enviandoIngrediente = true;
        const req = new IngredienteLoteProdutoComposicaoRequest();
        req.nome = nomeIngrediente;
        req.codigosProdutos = this.codigosProdutosIngrediente;

        this.produtoService.incluirIngredienteLote(req).subscribe({
            next: (res) => {
                if (res.success) {
                    const ingrediente = this.listaIngredientesGeral.find(i => i.nome.toLowerCase() === nomeIngrediente.toLowerCase());
                    this.ingredientesSaborSelecionado.push({ nome: nomeIngrediente, codigo: ingrediente?.codigo || 0 });
                    this.ingredientesSaborSelecionado = [...this.ingredientesSaborSelecionado]; // trigger change detection for pure component
                } else {
                    this.toastService.error('Erro ao adicionar ingrediente a todos os tamanhos');
                }
                this.enviandoIngrediente = false;
            },
            error: () => {
                this.toastService.error('Erro ao adicionar ingrediente');
                this.enviandoIngrediente = false;
            }
        });
    }

    public removerIngredienteDoProduto(ingrediente: IngredienteProdutoViewModel) {
        if (this.codigosProdutosIngrediente.length === 0) return;

        this.enviandoIngrediente = true;
        const req = new IngredienteLoteProdutoComposicaoRequest();
        req.nome = ingrediente.nome;
        req.codigosProdutos = this.codigosProdutosIngrediente;

        this.produtoService.deletarIngredienteLote(req).subscribe({
            next: (res) => {
                if (res.success) {
                    this.ingredientesSaborSelecionado = this.ingredientesSaborSelecionado.filter(i => i.nome !== ingrediente.nome);
                } else {
                    this.toastService.error('Erro ao remover ingrediente de todos os tamanhos');
                }
                this.enviandoIngrediente = false;
            },
            error: () => {
                this.toastService.error('Erro ao remover ingrediente');
                this.enviandoIngrediente = false;
            }
        });
    }
}

type TipoProduto = 'PIZZA' | 'LASANHA';